<app-banner [info]="true" heading="Applications" subHeading="View applications and download supporting documents">
</app-banner>

<div class="tabs-wrapper content">
  <div class="tabs">
    <button class="tab no-focus" (click)="resetFocus('prereg');" [class.selected]="tabSelected === 'prereg'">
      Student
    </button>
    <button class="tab no-focus" (click)="resetFocus('registrant');" [class.selected]="tabSelected === 'registrant'">
      Registrant
    </button>
  </div>
</div>

<div class="content no-boxes">
  @if (tabSelected === 'prereg') {
    <ul class="ol-style">
      @for (prereg of preregList; track prereg; let i = $index) {
        <li><button [class.active]="selectedIndex === i" (click)="setIndex(i, prereg)">{{prereg.title}}</button></li>
      }
    </ul>
  }
  @if (tabSelected === 'registrant') {
    <ul class="ol-style">
      @for (registrant of registrantList; track registrant; let i = $index) {
        <li><button [class.active]="selectedIndex === i" (click)="setIndex(i,registrant)">{{registrant.title}}</button></li>
      }
    </ul>
  }

  <form #searchForm="ngForm" class="searchForm">
    <div class="row">
      <div class="col-lg-12 parent-div">

        <div class="col-lg-6 padding-0">
          <div class="form-group">
            @if (tabSelected === 'prereg' || tabSelected === 'preregNew') {
              <div>
                <label for="search">
                  Search for an application by pre-entry number
                </label>
              </div>
            }
            @if (tabSelected === 'registrant') {
              <div>
                <label for="search">
                  Search for an application by registration number
                </label>
              </div>
            }

            @if (type==='prereg' || type==='preregNew') {
              <div>
                <div class="input-group">
                  <input type="text" #focus placeholder="Enter pre-entry number" id="search" [(ngModel)]="searchInput"
                    #input="ngModel" name="searchInput" (ngModelChange)="searchInputChanged()" class="form-control" required
                    minlength="7" maxLength="7">
                    <button class="ml-2 btn btn-primary btn-lg" type="submit" (click)="search()"
                    [disabled]="touched && searchForm?.invalid">Search</button>
                    <button class="ml-2 btn btn-primary btn-lg" (click)="clearsearch()"
                    [disabled]="touched && searchForm?.invalid">Clear</button>
                  </div>
                  <app-collapsible [trigger]="type==='prereg' && noResults">
                    <p class="form-error">
                      No applications found
                    </p>
                  </app-collapsible>
                  <app-collapsible [trigger]="touched && (input.errors?.minlength || input.errors?.maxlength)">
                    <p class="form-error">
                      Pre-entry number must be 7 characters
                    </p>
                  </app-collapsible>
                </div>
              }
              @if (type==='reg') {
                <div>
                  <div class="input-group">
                    <input type="text" #focus placeholder="Enter pre-entry number" id="search" [(ngModel)]="searchRegInput"
                      #reginput="ngModel" name="searchRegInput" (ngModelChange)="searchInputChanged()" class="form-control"
                      required minlength="7" maxLength="7">
                      <button class="ml-2 btn btn-primary btn-lg" type="submit" (click)="search()"
                      [disabled]="touched && searchForm?.invalid">Search</button>
                      <button class="ml-2 btn btn-primary btn-lg" (click)="clearsearch()"
                      [disabled]="touched && searchForm?.invalid">Clear</button>
                    </div>
                    <app-collapsible [trigger]="type==='reg' && noResults">
                      <p class="form-error">
                        No applications found
                      </p>
                    </app-collapsible>
                    <app-collapsible [trigger]="touched && (reginput.errors?.minlength || reginput.errors?.maxlength)">
                      <p class="form-error">
                        Pre-entry number must be 7 characters
                      </p>
                    </app-collapsible>
                  </div>
                }
                @if (type==='technician') {
                  <div>
                    <div class="input-group">
                      <input type="text" #focus placeholder="Enter pre-entry number" id="search" [(ngModel)]="searchTechInput"
                        #techinput="ngModel" name="searchTechInput" (ngModelChange)="searchInputChanged()" class="form-control"
                        required minlength="7" maxLength="7">
                        <button class="ml-2 btn btn-primary btn-lg" type="submit" (click)="search()"
                        [disabled]="touched && searchForm?.invalid">Search</button>
                        <button class="ml-2 btn btn-primary btn-lg" (click)="clearsearch()"
                        [disabled]="touched && searchForm?.invalid">Clear</button>
                      </div>
                      <app-collapsible [trigger]="type==='technician' && noResults">
                        <p class="form-error">
                          No applications found
                        </p>
                      </app-collapsible>
                      <app-collapsible [trigger]="touched && (techinput.errors?.minlength || techinput.errors?.maxlength) ">
                        <p class="form-error">
                          Pre-entry number must be 7 characters
                        </p>
                      </app-collapsible>
                    </div>
                  }
                  @if (type==='assessment-report') {
                    <div>
                      <div class="input-group">
                        <input type="text" #focus placeholder="Enter pre-entry number" id="search"
                          [(ngModel)]="searchAssessmentInput" #assessmentinput="ngModel" name="searchAssessmentInput"
                          (ngModelChange)="searchInputChanged()" class="form-control" required minlength="7" maxLength="7">
                          <button class="ml-2 btn btn-primary btn-lg" type="submit" (click)="search()"
                          [disabled]="touched && searchForm?.invalid">Search</button>
                          <button class="ml-2 btn btn-primary btn-lg" (click)="clearsearch()"
                          [disabled]="touched && searchForm?.invalid">Clear</button>
                        </div>
                        <app-collapsible [trigger]="type==='assessment-report' && progressReport === null">
                          <p class="form-error">
                            No progress report found
                          </p>
                        </app-collapsible>
                        <app-collapsible [trigger]="type==='assessment-report' && noResults">
                          <p class="form-error">
                            No applications found
                          </p>
                        </app-collapsible>
                        <app-collapsible
                          [trigger]="touched && (assessmentinput.errors?.minlength || assessmentinput.errors?.maxlength)">
                          <p class="form-error">
                            Pre-entry number must be 7 characters
                          </p>
                        </app-collapsible>
                      </div>
                    }
                    @if (type==='exam') {
                      <div>
                        <div class="input-group">
                          <input type="text" #focus placeholder="Enter pre-entry number" id="search" [(ngModel)]="searchExamInput"
                            #examinput="ngModel" name="searchExamInput" (ngModelChange)="searchInputChanged()" class="form-control"
                            required minlength="7" maxLength="7">
                            <button class="ml-2 btn btn-primary btn-lg" type="submit" (click)="search()"
                            [disabled]="touched && searchForm?.invalid">Search</button>
                            <button class="ml-2 btn btn-primary btn-lg" (click)="clearsearch()"
                            [disabled]="touched && searchForm?.invalid">Clear</button>
                          </div>
                          <app-collapsible [trigger]="type==='exam' && noResults">
                            <p class="form-error">
                              No applications found
                            </p>
                          </app-collapsible>
                          <app-collapsible [trigger]="touched && (examinput.errors?.minlength || examinput.errors?.maxlength)">
                            <p class="form-error">
                              Pre-entry number must be 7 characters
                            </p>
                          </app-collapsible>
                        </div>
                      }

                      @if (type==='finalDeclaration') {
                        <div>
                          <div class="input-group">
                            <input type="text" #focus placeholder="Enter pre-entry number" id="search"
                              [(ngModel)]="searchFinalDeclarationInput" #fdinput="ngModel" name="searchFinalDeclarationInput"
                              (ngModelChange)="searchInputChanged()" class="form-control" required minlength="7" maxLength="7">
                              <button class="ml-2 btn btn-primary btn-lg" type="submit" (click)="search()"
                              [disabled]="touched && searchForm?.invalid">Search</button>
                              <button class="ml-2 btn btn-primary btn-lg" (click)="clearsearch()"
                              [disabled]="touched && searchForm?.invalid">Clear</button>
                            </div>
                            <app-collapsible [trigger]="type==='finalDeclaration' && (noResults || (application && !application.progressReport))">
                              <p class="form-error">
                                No applications found
                              </p>
                            </app-collapsible>
                            <app-collapsible [trigger]="touched && (fdinput.errors?.minlength || fdinput.errors?.maxlength)">
                              <p class="form-error">
                                Pre-entry number must be 7 characters
                              </p>
                            </app-collapsible>
                          </div>
                        }
                        <!--independent prescriber-->

                        @if (type==='independentPrescriber') {
                          <div>
                            <div class="input-group">
                              <input type="text" #focus placeholder="Enter registration number" id="search" [(ngModel)]="searchPrescriberInput"
                                #prescriberinput="ngModel" name="searchPrescriberInput" (ngModelChange)="searchInputChanged()" class="form-control"
                                required minlength="7" maxLength="7">
                                <button class="ml-2 btn btn-primary btn-lg" type="submit" (click)="search()"
                                [disabled]="touched && searchForm?.invalid">Search</button>
                                <button class="ml-2 btn btn-primary btn-lg" (click)="clearsearch()"
                                [disabled]="touched && searchForm?.invalid">Clear</button>
                              </div>
                              <app-collapsible [trigger]="type==='independentPrescriber' && noResults">
                                <p class="form-error">
                                  No applications found
                                </p>
                              </app-collapsible>
                              <app-collapsible [trigger]="touched && (prescriberinput.errors?.minlength || prescriberinput.errors?.maxlength) ">
                                <p class="form-error">
                                  registration number must be 7 characters
                                </p>
                              </app-collapsible>
                            </div>
                          }

                          @if (type==='vr') {
                            <div>
                              <div class="input-group">
                                <input type="text" #focus placeholder="Enter registration number" id="search" [(ngModel)]="searchVRApplicant"
                                  #vrInput="ngModel" name="searchVRApplicant" (ngModelChange)="searchInputChanged()" class="form-control"
                                  required minlength="7" maxLength="7">
                                  <button class="ml-2 btn btn-primary btn-lg" type="submit" (click)="search()"
                                  [disabled]="touched && searchForm?.invalid">Search</button>
                                  <button class="ml-2 btn btn-primary btn-lg" (click)="clearsearch()"
                                  [disabled]="touched && searchForm?.invalid">Clear</button>
                                </div>
                                <app-collapsible [trigger]="type==='vr' && noResults">
                                  <p class="form-error">
                                    No applications found
                                  </p>
                                </app-collapsible>
                                <app-collapsible [trigger]="touched && (vrInput.errors?.minlength || vrInput.errors?.maxlength) ">
                                  <p class="form-error">
                                    registration number must be 7 characters
                                  </p>
                                </app-collapsible>
                              </div>
                            }

                            @if (type==='rtr') {
                              <div>
                                <div class="input-group">
                                  <input type="text" #focus placeholder="Enter registration number" id="search" [(ngModel)]="searchRTRApplicant"
                                    #rtrInput="ngModel" name="searchRTRApplicant" (ngModelChange)="searchInputChanged()" class="form-control"
                                    required minlength="7" maxLength="7">
                                    <button class="ml-2 btn btn-primary btn-lg" type="submit" (click)="search()"
                                    [disabled]="touched && searchForm?.invalid">Search</button>
                                    <button class="ml-2 btn btn-primary btn-lg" (click)="clearsearch()"
                                    [disabled]="touched && searchForm?.invalid">Clear</button>
                                  </div>
                                  <app-collapsible [trigger]="type==='rtr' && noResults">
                                    <p class="form-error">
                                      No applications found
                                    </p>
                                  </app-collapsible>
                                  <app-collapsible [trigger]="touched && (rtrInput.errors?.minlength || rtrInput.errors?.maxlength) ">
                                    <p class="form-error">
                                      registration number must be 7 characters
                                    </p>
                                  </app-collapsible>
                                </div>
                              }

                              @if (type==='ccps') {
                                <div>
                                  <div class="input-group">
                                    <input type="text" #focus placeholder="Enter registration number" id="search" [(ngModel)]="searchCCPSApplicant"
                                      #ccpsInput="ngModel" name="searchCCPSApplicant" (ngModelChange)="searchInputChanged()" class="form-control"
                                      required minlength="7" maxLength="7">
                                      <button class="ml-2 btn btn-primary btn-lg" type="submit" (click)="search()"
                                      [disabled]="touched && searchForm?.invalid">Search</button>
                                      <button class="ml-2 btn btn-primary btn-lg" (click)="clearsearch()"
                                      [disabled]="touched && searchForm?.invalid">Clear</button>
                                    </div>
                                    <app-collapsible [trigger]="type==='ccps' && noResults">
                                      <p class="form-error">
                                        No applications found
                                      </p>
                                    </app-collapsible>
                                    <app-collapsible [trigger]="touched && (ccpsInput.errors?.minlength || ccpsInput.errors?.maxlength) ">
                                      <p class="form-error">
                                        registration number must be 7 characters
                                      </p>
                                    </app-collapsible>
                                  </div>
                                }
                              </div>
                            </div>

                            @if (type==='vr') {
                              <div class="col-lg-6 del-btn-div">
                                <button [disabled]="!application || !applicationStatus || (applicationStatus && applicationStatus === 3)" class="ml-2 btn btn-primary btn-lg" (click)="deleteApplication('vr')">Delete</button>
                              </div>
                            }

                            @if (type==='ccps') {
                              <div class="col-lg-6 del-btn-div">
                                <button [disabled]="!application || !applicationStatus || (applicationStatus && applicationStatus === 3)" class="ml-2 btn btn-primary btn-lg" (click)="deleteApplication('ccps')">Delete</button>
                              </div>
                            }
                          </div>

                          <app-collapsible [trigger]="validationErrors.length">
                            @for (error of validationErrors; track error) {
                              <div class="form-error" style="margin-bottom:10px;">{{error}}</div>
                            }
                          </app-collapsible>

                        </div>
                      </form>

                      @if (searching) {
                        <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
                      }

                      <div class="fadein">
                        @if (type==='reg' && application) {
                          <div>
                            <app-reg-application [application]="application" [class.selected]="type === 'reg'"></app-reg-application>
                          </div>
                        }

                        @if ((type==='prereg' || type==='preregNew') && application) {
                          <div>
                            <app-prereg-application [application]="application" [class.selected]="type === 'prereg'"></app-prereg-application>
                          </div>
                        }
                        @if (type==='technician' && application) {
                          <div>
                            <app-technician-application [application]="application" [class.selected]="type === 'technician'">
                            </app-technician-application>
                          </div>
                        }

                        @if (type==='assessment-report' && (application && progressReport !== null)) {
                          <div>
                            <app-assessment-report-application [application]="application" [class.selected]="type === 'assessment-report'">
                            </app-assessment-report-application>
                          </div>
                        }

                        @if (type==='exam' && application) {
                          <div>
                            <app-assessment-registration-application [application]="application" [class.selected]="type === 'exam'">
                            </app-assessment-registration-application>
                          </div>
                        }

                        @if (type==='finalDeclaration' && application && application?.progressReport) {
                          <div>
                            <app-final-declaration-application [application]="application" [class.selected]="type === 'finalDeclaration'">
                            </app-final-declaration-application>
                          </div>
                        }

                        <!--independent prescriber-->

                        @if (type==='independentPrescriber' && application) {
                          <div>
                            <app-independent-prescriber-application [application]="application" [class.selected]="type === 'independentPrescriber'">
                            </app-independent-prescriber-application>
                          </div>
                        }

                        @if (type==='vr' && application) {
                          <div>
                            <app-voluntary-removal-application [application]="application" [class.selected]="type === 'vr'" [event]="eventSubject.asObservable()" (applicationDeleted)="onApplicationDelete($event)">
                            </app-voluntary-removal-application>
                          </div>
                        }

                        @if (type==='rtr' && application) {
                          <div>
                            <app-return-to-register-application [application]="application" [class.selected]="type === 'rtr'" >
                            </app-return-to-register-application>
                          </div>
                        }

                        @if (type==='ccps' && application) {
                          <div>
                            <app-ccps-application [application]="application" [class.selected]="type === 'ccps'" [event]="eventSubject.asObservable()" (applicationDeleted)="onApplicationDelete($event)"  >
                            </app-ccps-application>
                          </div>
                        }
                      </div>

                    </div>